/**
 * URL-driven Nombre de bebé detail data loader.
 * Sole owner of getNameInfo + getNameHistory for the detail view.
 */
(function (root, factory) {
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) {
    root.MomcozyBabyNameDetail = api;
    api.boot(root.document);
  }
})(typeof window !== 'undefined' ? window : null, function (browserRoot) {
  function stringArray(value) {
    if (Array.isArray(value)) {
      return value
        .map(String)
        .map(function (item) {
          return item.trim();
        })
        .filter(Boolean);
    }
    if (typeof value === 'string' && value.trim()) return [value.trim()];
    return [];
  }

  function internalSourcePath(value) {
    value = typeof value === 'string' ? value.trim() : '';
    return /^\/(?!\/)/.test(value) ? value : '';
  }

  function findNamedValues(list, name) {
    if (!Array.isArray(list)) return [];
    var match = list.find(function (item) {
      return (
        item &&
        String(item.name || '').toLowerCase() ===
          String(name || '').toLowerCase()
      );
    });
    return stringArray(match && match.values);
  }

  function extractArticleData(response) {
    if (!response || (response.result && response.result !== 'success'))
      return {};
    var raw = response.data !== undefined ? response.data : response;
    if (raw && typeof raw === 'object' && !Array.isArray(raw)) return raw;
    return {};
  }

  /**
   * True when API data has real content (not an empty success shell).
   * Empty shells still return objects with null/empty fields after search preflight was removed.
   */
  function hasMeaningfulValue(value) {
    if (value === null || value === undefined || value === false) return false;
    if (typeof value === 'string') return Boolean(value.trim());
    if (typeof value === 'number') return !Number.isNaN(value);
    if (Array.isArray(value)) {
      return value.some(function (item) {
        return hasMeaningfulValue(item);
      });
    }
    if (typeof value === 'object') {
      return Object.keys(value).some(function (key) {
        return hasMeaningfulValue(value[key]);
      });
    }
    return true;
  }

  function hasNameInfoContent(response) {
    if (!response || (response.result && response.result !== 'success'))
      return false;
    return hasMeaningfulValue(response.data);
  }

  function normalizeGenderValue(seedGender, apiGender) {
    var seed = String(seedGender || '')
      .trim()
      .toLowerCase();
    if (seed === 'm' || seed === 'male') seed = 'boy';
    if (seed === 'f' || seed === 'female') seed = 'girl';
    var api = String(apiGender || '')
      .trim()
      .toLowerCase();
    if (api === 'm' || api === 'male') api = 'boy';
    if (api === 'f' || api === 'female') api = 'girl';
    return seed || api || '';
  }

  function normalizeInfoResponse(response, seed, routeName) {
    if (!response || (response.result && response.result !== 'success')) {
      throw new Error('Name information request failed');
    }
    // Reject empty success shells so the UI shows not-found + retry instead of a blank page.
    if (!hasNameInfoContent(response)) {
      throw new Error('Name not found');
    }
    seed = seed && typeof seed === 'object' ? seed : {};
    var raw = response.data !== undefined ? response.data : response;
    var data =
      raw && typeof raw === 'object' && !Array.isArray(raw)
        ? raw.data || raw
        : {};
    var sourceUrl = internalSourcePath(
      typeof raw === 'string'
        ? raw
        : data.location || data.url || seed.location || ''
    );
    var meanings = stringArray(data.meanings || data.meaning);
    if (!meanings.length) meanings = stringArray(seed.meanings || seed.meaning);

    var variants = stringArray(data.variants || data.variant_names);
    if (!variants.length && data.old_variant_article) {
      variants = stringArray(data.old_variant_article.variants);
    }

    var similar = stringArray(data.similar || data.similar_names);
    if (!similar.length)
      similar = findNamedValues(data.similar_name_list, 'similar');

    return {
      name: String(
        data.name ||
          data.first_name ||
          seed.first_name ||
          seed.name ||
          routeName ||
          ''
      ).trim(),
      meanings: meanings,
      origin: String(data.origin || seed.origin || '').trim(),
      gender: normalizeGenderValue(seed.gender, data.gender),
      sourceUrl: sourceUrl,
      variants: variants,
      similar: similar
    };
  }

  function emptyCurve() {
    return { es: [], us: [], uk: [] };
  }

  function normalizeCurve(value) {
    value = value && typeof value === 'object' ? value : {};
    return {
      es: Array.isArray(value.es) ? value.es.slice() : [],
      us: Array.isArray(value.us) ? value.us.slice() : [],
      uk: Array.isArray(value.uk) ? value.uk.slice() : []
    };
  }

  function normalizeHistoryResponse(response) {
    if (!response || (response.result && response.result !== 'success')) {
      throw new Error('Name history request failed');
    }
    var data = response.data || response;
    if (!data || typeof data !== 'object')
      throw new Error('Name history response is invalid');
    return {
      name: String(data.name || '').trim(),
      f_curve_data: normalizeCurve(data.f_curve_data),
      m_curve_data: normalizeCurve(data.m_curve_data)
    };
  }

  function emptyHistory(name) {
    return {
      name: name || '',
      f_curve_data: emptyCurve(),
      m_curve_data: emptyCurve()
    };
  }

  function emptyInfo(seed, name) {
    seed = seed && typeof seed === 'object' ? seed : {};
    return {
      name: String(seed.first_name || seed.name || name || '').trim(),
      meanings: stringArray(seed.meanings || seed.meaning),
      origin: String(seed.origin || '').trim(),
      gender: String(seed.gender || '')
        .trim()
        .toLowerCase(),
      sourceUrl: internalSourcePath(seed.location || ''),
      variants: [],
      similar: []
    };
  }

  function getErrorText(error) {
    if (!error) return '';
    var chunks = [error.message, error.msg, error.reason, error.code];
    var data = error.data;
    if (data && typeof data === 'object') {
      chunks.push(
        data.message,
        data.msg,
        data.reason,
        data.error,
        data.error_code,
        data.code
      );
    } else if (typeof data === 'string') {
      chunks.push(data);
    }
    return chunks
      .filter(Boolean)
      .map(function (part) {
        return String(part);
      })
      .join(' ');
  }

  function isNameNotFoundError(error) {
    if (!error) return false;
    var status = Number(error.status);
    var text = getErrorText(error);
    if (/name not found|not found|unknown name|no such name/i.test(text))
      return true;
    if (
      (status === 400 || status === 404) &&
      /name|not\s*found|missing/i.test(text)
    )
      return true;
    if (status === 404) return true;
    return false;
  }

  function loadDetail(client, route, seed, signal) {
    if (
      !client ||
      typeof client.getNameInfo !== 'function' ||
      typeof client.getNameHistory !== 'function'
    ) {
      return Promise.reject(new Error('Detail request client is unavailable'));
    }
    return Promise.allSettled([
      client.getNameInfo(route.name, { signal: signal }),
      client.getNameHistory(route.name, { signal: signal })
    ]).then(function (results) {
      var output = {
        name: route.name,
        info: emptyInfo(seed, route.name),
        history: emptyHistory(route.name),
        articleData: {},
        errors: {}
      };

      if (results[0].status === 'fulfilled') {
        try {
          output.info = normalizeInfoResponse(
            results[0].value,
            seed,
            route.name
          );
          output.articleData = extractArticleData(results[0].value);
          output.name = output.info.name || route.name;
        } catch (error) {
          output.errors.info =
            (error && error.message) || 'Name information request failed';
          if (isNameNotFoundError(error)) output.errors.notFound = true;
        }
      } else {
        output.errors.info =
          (results[0].reason && results[0].reason.message) ||
          'Name information request failed';
        if (isNameNotFoundError(results[0].reason))
          output.errors.notFound = true;
      }

      if (results[1].status === 'fulfilled') {
        try {
          output.history = normalizeHistoryResponse(results[1].value);
          if (output.history.name) output.name = output.history.name;
        } catch (error) {
          output.errors.history =
            (error && error.message) || 'Name history request failed';
        }
      } else {
        output.errors.history =
          (results[1].reason && results[1].reason.message) ||
          'Name history request failed';
      }

      return output;
    });
  }

  function getUI() {
    return (browserRoot && browserRoot.MomcozyBabyNameUI) || null;
  }

  function clearPresentationRoot(root) {
    if (!root) return;
    root.dataset.currentName = '';
    root.dataset.originValue = '';
    root.dataset.currentRankGirl = '';
    root.dataset.currentRankBoy = '';
    var title = root.querySelector('[data-name-title]');
    if (title) title.textContent = '';
    var originSummary = root.querySelector('[data-origin-summary]');
    if (originSummary) originSummary.hidden = true;
    var originWrap = root.querySelector('[data-origin-stat-wrapper]');
    if (originWrap) originWrap.hidden = true;
    root.querySelectorAll('[data-related-group]').forEach(function (group) {
      group.hidden = true;
    });
    var articleShell = root.querySelector('[data-article-shell]');
    if (articleShell) articleShell.hidden = true;
    var meaningSummary = root.querySelector('[data-meaning-summary]');
    if (meaningSummary) {
      meaningSummary.textContent = '';
      meaningSummary.hidden = true;
    }
    var tocList = root.querySelector('[data-toc-list]');
    if (tocList) tocList.replaceChildren();
    var articleList = root.querySelector('[data-article-list]');
    if (articleList) articleList.replaceChildren();
  }

  var activeBoot = null;

  function boot(doc) {
    if (!browserRoot || !doc) return;
    if (activeBoot && activeBoot.doc === doc) return activeBoot;
    if (activeBoot && typeof activeBoot.destroy === 'function')
      activeBoot.destroy();

    var controller = null;
    var requestId = 0;
    var currentRoute = null;
    var currentSeed = null;
    var currentData = null;
    var abortController = browserRoot.AbortController
      ? new browserRoot.AbortController()
      : null;
    var signal = abortController ? abortController.signal : undefined;
    var listenerOpts = signal ? { signal: signal } : false;

    function roots() {
      return doc.querySelectorAll('[data-yg-bn-detail]');
    }

    function datasetLabel(root, key, fallback) {
      var value = root && root.dataset && root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    }

    function detailLabels() {
      var root = roots()[0];
      return {
        retry: datasetLabel(root, 'retryLabel', 'Reintentar'),
        retryInfo: datasetLabel(
          root,
          'retryInfoLabel',
          'Reintentar la información del nombre'
        ),
        retryHistory: datasetLabel(
          root,
          'retryHistoryLabel',
          'Reintentar el historial'
        ),
        loadingInfo: datasetLabel(
          root,
          'loadingInfo',
          'Cargando información del nombre…'
        ),
        loadingHistory: datasetLabel(
          root,
          'loadingHistory',
          'Cargando historial del nombre…'
        ),
        loadingDetail: datasetLabel(
          root,
          'loadingDetail',
          'Cargando detalles del nombre…'
        ),
        notFoundTemplate: datasetLabel(
          root,
          'notFoundTemplate',
          'No hemos encontrado información para el nombre «[[name]]».'
        ),
        errorUnavailable: datasetLabel(
          root,
          'errorUnavailable',
          'Los detalles del nombre no están disponibles temporalmente.'
        ),
        errorLoad: datasetLabel(
          root,
          'errorLoad',
          'No pudimos cargar este nombre. Inténtalo de nuevo.'
        ),
        errorPartial: datasetLabel(
          root,
          'errorPartial',
          'No se pudieron cargar algunos detalles del nombre.'
        )
      };
    }

    function applyNameTemplate(template, name) {
      return String(template || '')
        .split('[[name]]')
        .join(name || '');
    }

    function setDataLoading(loading, message) {
      var ui = getUI();
      roots().forEach(function (root) {
        if (ui && typeof ui.setDataLoading === 'function') {
          ui.setDataLoading(root, loading, message);
        } else {
          if (loading) root.setAttribute('aria-busy', 'true');
          else root.removeAttribute('aria-busy');
        }
      });
    }

    function setStatus(message, kind, failedParts) {
      roots().forEach(function (root) {
        var status = root.querySelector('[data-baby-name-detail-status]');
        if (!status) {
          status = doc.createElement('div');
          status.setAttribute('data-baby-name-detail-status', '');
          status.setAttribute('role', 'status');
          status.className = 'yg-bn-detail__status';
          root.prepend(status);
        }
        status.replaceChildren();
        status.hidden = !message;
        status.setAttribute('data-state', kind || 'info');
        if (!message) return;
        status.appendChild(doc.createTextNode(message));
        if (kind === 'error') {
          (failedParts && failedParts.length ? failedParts : ['all']).forEach(
            function (part) {
              var retry = doc.createElement('button');
              retry.type = 'button';
              retry.className = 'yg-bn-detail__retry';
              var labels = detailLabels();
              retry.textContent =
                part === 'info'
                  ? labels.retryInfo
                  : part === 'history'
                    ? labels.retryHistory
                    : labels.retry;
              retry.setAttribute('data-baby-name-detail-retry', part);
              status.appendChild(doc.createTextNode(' '));
              status.appendChild(retry);
            }
          );
        }
      });
    }

    function clearPresentation() {
      roots().forEach(function (root) {
        clearPresentationRoot(root);
      });
    }

    function emit(data) {
      doc.dispatchEvent(
        new browserRoot.CustomEvent('baby-names:detail-data', {
          bubbles: true,
          detail: data
        })
      );
    }

    function emptyData() {
      return {
        name: (currentRoute && currentRoute.name) || '',
        info: emptyInfo(currentSeed, currentRoute && currentRoute.name),
        history: emptyHistory(currentRoute && currentRoute.name),
        articleData: {},
        errors: {}
      };
    }

    function abortActive() {
      if (controller) {
        controller.abort();
        controller = null;
      }
    }

    function request(part) {
      if (!currentRoute || currentRoute.view !== 'detail') return;
      abortActive();
      controller =
        typeof browserRoot.AbortController === 'function'
          ? new browserRoot.AbortController()
          : null;
      var activeController = controller;
      var activeRequestId = ++requestId;
      var signal = activeController && activeController.signal;
      var client = browserRoot.MomcozyBabyNameRequest;
      var labels = detailLabels();
      var loadingMessage =
        part === 'info'
          ? labels.loadingInfo
          : part === 'history'
            ? labels.loadingHistory
            : labels.loadingDetail;

      // Unified data-loading is the visible pending state; status retries are rebuilt after the request.
      setDataLoading(true, loadingMessage);
      setStatus('', 'loading');

      if (
        !client ||
        typeof client.getNameInfo !== 'function' ||
        typeof client.getNameHistory !== 'function'
      ) {
        setDataLoading(false);
        setStatus(labels.errorUnavailable, 'error', part ? [part] : ['all']);
        return;
      }

      var task;
      if (part === 'info') {
        task = client
          .getNameInfo(currentRoute.name, { signal: signal })
          .then(function (response) {
            return {
              part: 'info',
              value: normalizeInfoResponse(
                response,
                currentSeed,
                currentRoute.name
              ),
              articleData: extractArticleData(response)
            };
          });
      } else if (part === 'history') {
        task = client
          .getNameHistory(currentRoute.name, { signal: signal })
          .then(function (response) {
            return {
              part: 'history',
              value: normalizeHistoryResponse(response)
            };
          });
      } else {
        task = loadDetail(client, currentRoute, currentSeed, signal);
      }

      task
        .then(function (data) {
          if (activeRequestId !== requestId) return;
          if (signal && signal.aborted) return;
          if (part) {
            currentData = currentData || emptyData();
            currentData[data.part] = data.value;
            if (data.part === 'info') {
              currentData.articleData = data.articleData || {};
              currentData.name = data.value.name || currentData.name;
              delete currentData.errors.notFound;
            }
            if (data.part === 'history' && data.value && data.value.name) {
              currentData.name = data.value.name;
            }
            delete currentData.errors[data.part];
          } else {
            currentData = data;
          }
          emit(currentData);
          applyResultStatus(currentData);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          if (activeRequestId !== requestId) return;
          if (part) {
            currentData = currentData || emptyData();
            currentData.errors[part] =
              (error && error.message) || 'Request failed';
            if (part === 'info' && isNameNotFoundError(error))
              currentData.errors.notFound = true;
            emit(currentData);
            applyResultStatus(currentData);
          } else {
            // Stay on detail view; surface error + retry without navigating away.
            currentData = emptyData();
            currentData.errors.detail =
              (error && error.message) || 'Name detail request failed';
            emit(currentData);
            setStatus(detailLabels().errorLoad, 'error', ['all']);
          }
        })
        .then(function () {
          if (activeRequestId !== requestId) return;
          setDataLoading(false);
        });
    }

    function applyResultStatus(data) {
      data = data || emptyData();
      var labels = detailLabels();
      var failed = Object.keys(data.errors || {}).filter(function (key) {
        return key !== 'notFound';
      });
      if (data.errors && data.errors.notFound) {
        setStatus(
          applyNameTemplate(labels.notFoundTemplate, data.name || ''),
          'error',
          failed.length ? failed : ['info']
        );
        return;
      }
      setStatus(
        failed.length ? labels.errorPartial : '',
        failed.length ? 'error' : 'info',
        failed
      );
    }

    function applyRoute(event) {
      var detail = (event && event.detail) || {};
      var route = detail.route;
      if (!route || route.view !== 'detail') {
        currentRoute = null;
        currentSeed = null;
        currentData = null;
        abortActive();
        setDataLoading(false);
        setStatus('', 'info');
        return;
      }

      currentRoute = route;
      currentSeed = detail.seed || null;

      // Always clear stale presentation and show loading before the new request.
      clearPresentation();
      currentData = emptyData();
      emit(currentData);
      request();
    }

    function onRetryClick(event) {
      var retry = event.target.closest('[data-baby-name-detail-retry]');
      if (!retry) return;
      var part = retry.getAttribute('data-baby-name-detail-retry') || null;
      if (part === 'all') part = null;
      // Brief button loading feedback; setStatus rebuilds the status row after request settles.
      var ui = getUI();
      if (ui && typeof ui.setButtonLoading === 'function') {
        ui.setButtonLoading(retry, true);
      } else {
        retry.classList.add('is-loading');
        retry.disabled = true;
        retry.setAttribute('aria-disabled', 'true');
      }
      request(part);
    }

    doc.addEventListener('baby-names:route-change', applyRoute, listenerOpts);
    doc.addEventListener('click', onRetryClick, listenerOpts);

    var flow = browserRoot.MomcozyBabyNameFlow;
    if (flow && typeof flow.parseRoute === 'function') {
      applyRoute({
        detail: {
          route: flow.parseRoute(browserRoot.location.search),
          seed: browserRoot.history.state && browserRoot.history.state.seed
        }
      });
    }

    activeBoot = {
      doc: doc,
      destroy: function () {
        if (abortController) abortController.abort();
        abortActive();
        if (activeBoot && activeBoot.doc === doc) activeBoot = null;
      }
    };
    return activeBoot;
  }

  return {
    hasMeaningfulValue: hasMeaningfulValue,
    hasNameInfoContent: hasNameInfoContent,
    isNameNotFoundError: isNameNotFoundError,
    normalizeInfoResponse: normalizeInfoResponse,
    normalizeHistoryResponse: normalizeHistoryResponse,
    extractArticleData: extractArticleData,
    clearPresentationRoot: clearPresentationRoot,
    loadDetail: loadDetail,
    boot: boot
  };
});
